import {
	CLEAR_ALL_USERS_DATA,
	CLEAR_ALL_USERS_ERRORS,
	CLEAR_USERS_ERROR,
	SEARCH_USER_LOADING,
	SEARCH_USER_GET,
	SEARCH_USER_ERROR
} from '../actions/types';

const initialState = {
	search_user_loading: false,
	users_found: { count: 0, users: [] },
	users_errors: {}
}

export default function usersReducer (state = initialState, action) {
	switch (action.type) {
		case CLEAR_ALL_USERS_ERRORS:
			return {
				...state,
				users_errors: {}
			}
		case CLEAR_USERS_ERROR:
			return {
				...state,
				users_errors: Object.keys(state.users_errors).reduce((acc, key) => {
					if (key !== action.payload) {
						acc[key] = state.users_errors[key];
					}
					return acc;
				}, {})
			}
		case SEARCH_USER_LOADING:
			return {
				...state,
				search_user_loading: action.payload
			}
		case SEARCH_USER_GET:
			return {
				...state,
				users_found: {
					count: action.payload.count,
					users: action.payload.users
				}
			}
		case SEARCH_USER_ERROR:
			return {
				...state,
				users_errors: {
					...state.users_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
